export const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    hot: true,
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    hot: false,
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    hot: false,
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-archive-line",
    hot: true,
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-links-line",
    hot: false,
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-customer-service-2-line",
    hot: false,
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    hot: true,
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-checkbox-blank-line",
    hot: false,
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-football-line",
    hot: false,
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    hot: false,
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    hot: false,
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    hot: false,
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-contrast-drop-line",
    hot: false,
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    hot: false,
  },
];